/**
 * Stable target-category codes (011 contract §6). Keep in sync with
 * `SadeceBilgisayar.DATA.Models.AdminActionLog.AdminActionTargetType`.
 */
export type AdminActionTargetType = 'Listing' | 'User' | 'SupportTicket';

export const ADMIN_ACTION_TARGET_TYPES: readonly AdminActionTargetType[] = [
  'Listing',
  'User',
  'SupportTicket',
] as const;
